import React, { forwardRef, useImperativeHandle } from 'react';
import { FormGroup, Input, message, Select } from '@tencent/spaui';
import useFormEdit from 'business-components/use-form-edit';
import InputMaxLimit from 'components/input-max-limit';
import { LoginNameType, LoginType, Operator, OperatorRole } from 'model/operator';
import { OPERATOR_ROLE_MAP, LOGIN_TYPE_LIST } from 'config/constants';
import { addOperator, updateOperator } from '../services';
import { formFieldConfig } from '../config';

const initData = {
  operator_role: OperatorRole.operator,
  login_type: LoginType.qq,
};

const loginTypeMap: Record<string, LoginNameType> = LOGIN_TYPE_LIST.reduce(
  (map, v) => ({ ...map, [v.value]: v.login_name_type }),
  {}
);

const operatorList = [{ value: OperatorRole.operator, label: OPERATOR_ROLE_MAP[OperatorRole.operator] }];

interface OperatorEditProps {
  payload: {
    data?: any;
  };
}

interface RefProps {
  onSubmit: () => void;
}

const OperatorEdit: React.ForwardRefRenderFunction<RefProps, OperatorEditProps> = (props, ref) => {
  const data = props.payload?.data;

  const { formData, formError, onChange, onBatchChange, onSubmit } = useFormEdit({
    config: formFieldConfig,
    data: data || initData,
  });

  useImperativeHandle(ref, () => ({
    onSubmit: async () => {
      const formData = onSubmit();
      if (!formData) {
        throw new Error();
      }
      const { operator_id, operator_name, operator_role, mobile, login_type, login_name, comment } = formData;
      const data: Operator = {
        operator_name,
        operator_role,
        mobile,
        comment,
        logins: {
          login_name,
          login_type,
          login_name_type: loginTypeMap[login_type],
        },
      };
      let service = addOperator;
      let label = '添加';
      if (operator_id) {
        data.operator_id = operator_id;
        service = updateOperator;
        label = '编辑';
      }
      const res = await service(data);
      if (res) {
        message.success(`${label}成员成功`);
        return true;
      }
      return false;
    },
  }));
  return (
    <div className="mini-form">
      <div className="form-item">
        <div className="form-item-label">成员姓名</div>
        <div className="form-item-component">
          <FormGroup
            error={formError.operator_name}
            feedback={<InputMaxLimit max={10} value={formData.operator_name?.length} />}
          >
            <Input
              placeholder="请输入成员姓名"
              value={formData.operator_name}
              underlined
              onChange={(e: EventTarget, value: string) => onChange(e, 'operator_name', value)}
            />
          </FormGroup>
        </div>
      </div>
      <div className="form-item">
        <div className="form-item-label">平台角色</div>
        <div className="form-item-component">
          <FormGroup error={formError.operator_role}>
            <Select
              placeholder="请选择平台角色"
              data={operatorList}
              value={formData.operator_role}
              onChange={(e: EventTarget, value: string) => onChange(e, 'operator_role', value)}
              className="underlined"
            />
          </FormGroup>
        </div>
      </div>
      <div className="form-item">
        <div className="form-item-label">手机号码</div>
        <div className="form-item-component">
          <FormGroup error={formError.mobile}>
            <Input
              placeholder="请输入手机号码"
              value={formData.mobile}
              underlined
              onChange={(e: EventTarget, value: string) => onChange(e, 'mobile', value)}
            />
          </FormGroup>
        </div>
      </div>
      <div className="form-item">
        <div className="form-item-label">登陆账号</div>
        <div className="form-item-component row">
          <Select
            data={LOGIN_TYPE_LIST}
            value={formData.login_type}
            onChange={(e: EventTarget, value: string) => onBatchChange(e, { login_type: value, login_name: '' })}
            className="underlined"
            style={{ width: '100px' }}
          />
          <FormGroup error={formError.login_name} style={{ flex: 1 }}>
            <Input
              placeholder="请输入登陆账号"
              value={formData.login_name}
              underlined
              onChange={(e: EventTarget, value: string) => onChange(e, 'login_name', value)}
            />
          </FormGroup>
        </div>
      </div>
      <div className="form-item align-top">
        <div className="form-item-label">备注</div>
        <div className="form-item-component">
          <FormGroup error={formError.comment} feedback={<InputMaxLimit max={10} value={formData.comment?.length} />}>
            <Input
              placeholder="请输入备注"
              tagType="textarea"
              value={formData.comment}
              onChange={(e: EventTarget, value: string) => onChange(e, 'comment', value)}
            />
          </FormGroup>
        </div>
      </div>
    </div>
  );
};

export default forwardRef(OperatorEdit);
